
let baseUrl = 'https://admin.test.iocrm.iovision.io';

export const environment = {
  baseUrl,
  production: false,
  apiUrl: baseUrl+'/api',
  //  // adjust this to your Strapi URL
}; 